<template>
  <div
    :class="['visual', $store.state.iframeMode !== false ? 'visual--iframe-mode' : null]"
    :style="`background-image: url(${require(`@/assets/img/backgrounds/category/${image}_big.jpg`)});`"
  >
    <div class="container">
      <div class="visual__box">
        <h1 class="size--xxl" v-html="headline"></h1>
      </div>
      <Icon v-if="icon" class="headline-icon" set="features" :id="icon" />
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon.vue';

export default {
  components: {
    Icon,
  },
  props: {
    headline: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.visual {
  background: $color-contrast-light no-repeat center;
  background-size: cover;
  background-position: center;
  height: 50vh;
  margin-bottom: $section-spacing;
  padding: $section-spacing 0;
  animation: fadeZoomIn .4s ease-out;

  &--iframe-mode {
    margin-bottom: 0;

    .button {
      margin-top: 20px;
    }
  }

  .container {
    height: 100%;
    display: flex;
    align-items: flex-end;
  }

  &__box {
    background-color: rgba($color-secondary-light, .9);
    padding: 25px;
    display: inline-block;
    color: $color-white;
    animation: moveUp .4s ease-out;
  }

  @include tablet {
    height: 380px;

    &--iframe-mode {
      height: 100vh;

      .container {
        justify-content: center;
      }

      .visual__box {
        max-width: 100%;
      }
    }

    .container {
      justify-content: flex-end;
    }

    &__box {
      max-width: 90%;
    }
  }
}
.headline-icon {
  flex-basis: 89px;
  background: $color-primary;
  animation: moveUp .4s ease-out;
}
</style>
